import React from 'react';
/*import DEBUG from "config/debug.js"*/
// Component
import NoteRow from '../Row/NoteRow.js';
import ModalCommentList from '../Modal/ModalCommentList.js';
import ModalAddNote from '../Modal/ModalAddNote.js';

import Request from "../../../../../config/Request.js"

import windowStop from 'utils/windowStop.js'

export default class TabNotes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      raw_data      : [],
      modalComment  : false,
      modalAddNote  : false,
      SelectedNote  : null,
      note_count    : 0,
      next          : null,
      current       : null,
      is_loading_loadmore: true,
    }

    this.is_loading = true
    this.toggleModalComment = this.toggleModalComment.bind(this);
    this.closeModalComment  = this.closeModalComment.bind(this);
    this.toggleModalAddNote = this.toggleModalAddNote.bind(this);
    this.closeModalAddNote  = this.closeModalAddNote.bind(this);
    this.updateNote         = this.updateNote.bind(this);

    this.onRead = this.onRead.bind(this)
    this.onReadSuccess = this.onReadSuccess.bind(this)
    this.onReadFailed = this.onReadFailed.bind(this)
    this.updateCounterComment = this.updateCounterComment.bind(this)

    this._mounted = false
  }

  updateCounterComment(selected_note, new_count) {
    const {raw_data} = this.state
    let alias_note = selected_note.Alias
    
    for (let i = 0; i < raw_data.length; i++) {
      if(raw_data[i].Alias === alias_note) {
        raw_data[i].CommentCount = new_count
      }
    }
  }

  toggleModalComment(e, data){
    e.preventDefault();
    this.setState({
      modalComment: true,
      SelectedNote: data
    })
  }

  closeModalComment() {
    this.setState({
      modalComment: false,
    })
  }

  toggleModalAddNote(e){
  	e.preventDefault();
  	this.setState({
  		modalAddNote: true,
  	})
  }

  closeModalAddNote() {
    this.setState({
      modalAddNote: false,
    })
  }

  generateRow(row) {
  	var element = row.map((val, index) => {
  		return (
        <NoteRow
          key={index}
          RowData={val}
          toggleModalComment={this.toggleModalComment}
        />
      )
  	})
  	return element;
  }

  updateNote(data) {
    data.CommentCount = 0

    let tmpData = this.state.raw_data;
    tmpData.unshift(data)

    this.setState({
      raw_data: tmpData,
      note_count: this.state.note_count + 1
    })

  }

  onRead(loadmore=false){
    let payload

    if(loadmore) {
      if(this.state.next !== null) {
        payload = {
          page: this.state.current + 1,
          ordering: "-CreatedTime",
        }
      }
    }else {
      payload = {
        ordering: "-CreatedTime",
      }
      this.is_loading = true
    }

    Request(
      "get",
      "read-notes",
      {"Authorization" : "Bearer " + this.props.UserReducer.token},
      payload,
      [this.props.SelectedItem.Alias],
      this.onReadSuccess,
      this.onReadFailed
    )
  }

  onReadSuccess(response){
    if(this.state.next === null) {
      this.is_loading = false
      this.setState({
        note_count          : response.data.count,
        raw_data            : response.data.results,
        next                : response.data.next,
        current             : response.data.current,
        is_loading_loadmore : false
      })
    } else {
      // Loadmore
      this.is_loading = false
      this.setState({
        note_count          : response.data.count,
        raw_data            : [...this.state.raw_data, ...response.data.results],
        next                : response.data.next,
        current             : response.data.current,
        is_loading_loadmore : false
      })
    }

  }

  onReadFailed(){
    this.is_loading = false
    this.setState({
      is_loading_loadmore: false
    })
  }

  hasMounted() {
    if(this._mounted) {
      this.onRead()
    }
  }

  componentDidMount() {
    this._mounted = true
    this.hasMounted()
  } 
  componentWillUnmount() {
    this._mounted = false
    windowStop()
  }

  LoadMore() {
    this.setState({
      is_loading_loadmore: true
    })
    this.onRead(true)
  }

  renderLoadMore(){
    if(this.state.is_loading_loadmore) {
      return(
        <div><button className="btn btn-default" disabled><i className="fa fa-spinner fa-pulse fa-fw"></i>&nbsp;Loading</button></div>
      )
    } else {
      if(this.state.next != null) {
        return (<div><button className="btn btn-primary" onClick={()=> {this.LoadMore()}}>Load More</button></div>)
      }
    }
  }

  RenderRowElement() {
    if(this.is_loading) {
      return (
        <div className="comment-not-found">
          <p style={{'marginTop': '3rem', 'marginBottom': '2rem'}} className="text-response-empty">Loading Notes...</p>
        </div>
      )
    }else {
      if(this.state.note_count > 0) {
        return this.generateRow(this.state.raw_data)
      } else {
        return (
          <div className="comment-not-found">
            <p style={{'marginTop': '3rem', 'marginBottom': '2rem'}} className="text-response-empty"><span className="icon-drawer"></span>&nbsp;Notes empty</p>
          </div>
        )
      }
    }
  }

  render() {
    return (
      <div>
      	<div className="list-separator">
      		<div className="item-inner">Note List
            <span>({this.is_loading ? "Loading..." : this.state.note_count})</span>
            <a href="" tabIndex="0" role="button" onClick={(e)=>this.toggleModalAddNote(e)} className="pull-right">Add Note</a>
          </div>
      	</div>
      	{this.RenderRowElement()}
        <div className="col-md-12 text-center" style={{"marginTop":"1rem"}}>
          {this.renderLoadMore()}
        </div>
      	<ModalCommentList
					UserReducer       = {this.props.UserReducer}
          closeModalComment = {this.closeModalComment}
          isOpen            = {this.state.modalComment}
          SelectedNote      = {this.state.SelectedNote}
          SelectedAsset     = {this.props.SelectedItem}
          ParentState       = {this.state}
          updateCounterComment={this.updateCounterComment}>
        </ModalCommentList>
        <ModalAddNote
          UserReducer       = {this.props.UserReducer}
          closeModalAddNote = {this.closeModalAddNote}
					isOpen            = {this.state.modalAddNote}
          updateNote        = {this.updateNote}
          SelectedAsset     = {this.props.SelectedItem}
          ParentState       = {this.state}>
        </ModalAddNote>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/asset/simple_asset/helper/component/Tab/TabNotes.js